import React from 'react';
import { ListItem, ListItemText, Box } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import DurationTextField from '../form-elements/DurationTextField';
import TooltipHelpButton from '../buttons/TooltipHelpButton/TooltipHelpButton';
import WarningButton from '../buttons/WarningButton';

const styles = theme => ({
    secondaryItem: {
        width: theme.spacing(8)
    }
});

class DurationTextFieldListItem extends React.Component {
    render() {
        const { classes, text, onChange, toolTip, warning, ariaLabel, value, ...other } = this.props

        return (
            <ListItem 
                {...other}
            >
                <ListItemText>
                    {text}
                    {toolTip ? 
                        <TooltipHelpButton
                            title={toolTip}
                        /> : null
                    }
                    {warning ? 
                        <WarningButton
                            title={warning}
                        /> : null
                    }
                </ListItemText>
                <Box className={classes.secondaryItem}>
                    <DurationTextField
                        value={value}
                        onChange={onChange}
                        ariaLabel={ariaLabel}
                    />
                </Box>
            </ListItem>
        );
    }
}

export default withStyles(DurationTextFieldListItem, styles);